import { ContactsActionTypes } from './types';

// common success
export const contactsApiResponseSuccess = (actionType: string, data: any) => ({
    type: ContactsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data }
});
// common error
export const contactsApiResponseError = (
    actionType: string,
    error: string
) => ({
    type: ContactsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error }
});

export const getContacts = (filters?: object) => ({
    type: ContactsActionTypes.GET_CONTACTS,
    payload: filters
});

export const updateSearch = (search: string) => ({
    type: ContactsActionTypes.UPDATE_SEARCH,
    payload: search
});

export const updateCurrentPage = (page: number) => ({
    type: ContactsActionTypes.UPDATE_CURRENT_PAGE,
    payload: page
});

export const createContact = (data: any) => ({
    type: ContactsActionTypes.CREATE_CONTACT,
    payload: data
});

export const editContact = (data: any, personId: string) => ({
    type: ContactsActionTypes.EDIT_CONTACT,
    payload: { data, personId }
});

export const deleteContact = (personId: string) => ({
    type: ContactsActionTypes.DELETE_CONTACT,
    payload: personId
});

export const resetContacts = (flag: string, value: any) => ({
    type: ContactsActionTypes.RESET_CONTACTS,
    payload: { flag, value }
});
